import React from "react";
import { FaDumpsterFire } from "react-icons/fa";

import styles from "./CrashDialog.module.css";

export interface CrashDialogProps {
  error: any;
}

function CrashDialog(props: CrashDialogProps): JSX.Element {
  return (
    <div className={styles.card}>
      <h1>
        <FaDumpsterFire size={40} /> Error: The App Crashed <FaDumpsterFire size={40} />
      </h1>
      <hr />
      <pre>
        <strong>{props.error.message}</strong>
        {"\n\n"}
        {props.error.stack}
      </pre>
    </div>
  );
}

export default CrashDialog;
